// 多级菜单
import Layout from '@/views/layout'
// 公共页面
import MultilevelRouting from '@/components/multilevelRouting'
export default {
  path: '/carMonitor',
  menuName: '车辆监控',
  component: Layout,
  redirect: 'noredirect',
  name: 'carMonitor',
  meta: { title: 'carmonitor', icon: 'car-monitor', iconType: 'svg' },
  children: [
    {
      path: 'carstatus',
      name: 'carstatus',
      menuName: '车辆状态查询',
      component: () => import('@/views/carMonitor/carStatus'),
      meta: { title: 'carstatus', icon: 'carstatus', iconType: 'svg' }
    },
    {
      path: 'remoteControl',
      name: 'remoteControl',
      menuName: '远程控制',
      component: MultilevelRouting,
      meta: { title: 'remoteControl', icon: 'remoteControl', iconType: 'svg' },
      children: [
        {
          path: 'monitorinfo/terminalbatch',
          name: 'terminalbatch',
          menuName: '下发命令包',
          component: () => import('@/views/carMonitor/monitorinfo/terminalBatch'),
          meta: { title: 'terminalbatch' }
        },
        {
          path: 'monitorinfo/terminalControl',
          name: 'terminalControl',
          menuName: '远程终端控制与设置',
          component: () => import('@/views/carMonitor/monitorinfo/terminalControl'),
          meta: { title: 'terminalbatch' }
        }
      ]
    }
  ]
}